import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from "../ui/table";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "../ui/select";
import { Button } from "../ui/button";
import { Pencil } from "lucide-react";

const formatMoney = (n) =>
  new Intl.NumberFormat("es-MX", { style: "currency", currency: "MXN", maximumFractionDigits: 0 }).format(Number(n) || 0);

const STATUS_BADGE = {
  available: "bg-emerald-100 text-emerald-800",
  reserved: "bg-amber-100 text-amber-800",
  sold: "bg-red-100 text-red-800",
};

export default function InventoryTable({ items, userRole, onStatus, onEdit }) {
  return (
    <div className="border border-slate-200 rounded-md bg-white overflow-x-auto">
      <Table>
        <TableHeader>
          <TableRow>
            <TableHead>ID</TableHead>
            <TableHead>Mz-Lt</TableHead>
            <TableHead>Área</TableHead>
            <TableHead>Precio</TableHead>
            <TableHead>Estado</TableHead>
            {userRole === "admin" && <TableHead className="text-right">Acciones</TableHead>}
          </TableRow>
        </TableHeader>
        <TableBody>
          {items.map((lot) => (
            <TableRow key={lot.id}>
              <TableCell className="font-mono">{lot.id}</TableCell>
              <TableCell>{lot.mzlt || lot.block}</TableCell>
              <TableCell>{lot.area || lot.size} m²</TableCell>
              <TableCell>{formatMoney(lot.precio || lot.price)}</TableCell>
              <TableCell>
                <Select value={lot.status} onValueChange={(v) => onStatus(lot, v)} disabled={userRole !== "admin"}>
                  <SelectTrigger className={`w-36 ${STATUS_BADGE[lot.status]} border-0 font-medium ${userRole !== 'admin' ? 'opacity-80' : ''}`}>
                    <SelectValue />
                  </SelectTrigger>
                  <SelectContent>
                    <SelectItem value="available">Disponible</SelectItem>
                    <SelectItem value="reserved">Reservado</SelectItem>
                    <SelectItem value="sold">Vendido</SelectItem>
                  </SelectContent>
                </Select>
              </TableCell>
              {userRole === "admin" && (
                <TableCell className="text-right">
                  <Button size="sm" variant="outline" onClick={() => onEdit(lot)}>
                    <Pencil size={14} className="mr-1" /> Editar
                  </Button>
                </TableCell>
              )}
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </div>
  );
}